import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import { Button } from "@blueprintjs/core";
import CreateNewCircleDecorator from '../../containers/CreateNewCircleDecorator';
export default class ReadyToCoOwnSection extends Component {
  render() {
    return (
      <section className="cta-section">
        
          <div className="main-container">
            <div className="content-wrapper">
              <div className="main-cta-split">
                <div className="copy">
                  <h1 className="hero-heading">
                    <Translate value="home.ready_to_co_own.heading" />
                  </h1>
                  <h2 className="bp3-heading light opacity90">
                    <Translate value="home.ready_to_co_own.sub_heading" />
                  </h2>
                </div>
                <CreateNewCircleDecorator empty_circle >
                  <Button
                    intent="primary"
                    className="cta primary-on-dark"
                    fill={true}>
                    <Translate value="home.ready_to_co_own.button" />
                  </Button>
                </CreateNewCircleDecorator>
              </div>
            </div>
          </div>
      </section>
    );
  }
}
